export const NSC_URN_OPERATIONS = {
  Boost: 'Boost',
  Borrow: 'Borrow',
  Deposit: 'Deposit',
  Liquidation: 'Liquidation',
  Repay: 'Repay',
  Unknown: 'Unknown',
  Unwind: 'Unwind',
  Withdraw: 'Withdraw',
  Grab: 'Grab'
};

export const LSE_EVENTS = {
  Wipe: 'Wipe',
  Draw: 'Draw',
  Free: 'Free',
  Lock: 'Lock',
  OnKick: 'On Kick',
  FreeSky: 'Free Sky'
};

export const PSM_URN_OPERATIONS = {
  Boost: 'Generate',
  Liquidation: 'Grab',
  Unwind: 'Payback'
};

export const LITE_PSM_URN_OPERATIONS = {
  Borrow: 'Generate',
  Liquidation: 'Grab',
  Repay: 'Payback'
};

export const FARM_EVENTS = {
  Staked: 'Staked',
  Withdrawn: 'Withdrawn',
  RewardPaid: 'RewardPaid'
};

export const FARM_CHRONICLE_EVENTS = {
  Staked: 'Staked',
  Withdrawn: 'Withdrawn'
};
export const SYMBOLS_PALETTE = {
  'UNI-V2': '#ff007a',
  'UNI-V2 (USDS-SKY)': '#ff007a',
  'UNI-V2 (SKY)': '#ff007a',
  'UNI-V2 (USDS)': '#ff007a',
  'Surplus (USDS)': '#e4bc38',
  Locked: '#f97316',
  'Non-Circulating': '#dc2626',
  'Not-Migrated': '#16a34a',
  Circulating: '#00f5aa',
  Sky: '#e4bc38',
  '**Sky': '#e4bc38',
  '**Allocated Genesis Capital': '#e4bc38',
  Spark: '#fa43bd',
  Grove: '#235c41',
  AAVE: '#2ebac6',
  BAL: '#E5d3BE',
  BAT: '#ff5000',
  COMP: '#00d395',
  DAI: '#F4B731',
  ETH: '#959190',
  GNO: '#00CEC4',
  GUSD: '#26ddf9',
  KNC: '#31cb9e',
  LINK: '#2a5ada',
  LRC: '#1c42ff',
  MANA: '#ff2d55',
  MATIC: '#7b3fe4',
  Others: '#E0E0E0',
  others: '#E0E0E0',
  PAX: '#cdeefc',
  renBTC: '#e65231',
  rETH: '#f27852',
  sDAI: '#8BC34A',
  steCRV: '#a5a4ce',
  TUSD: '#2b2e7f',
  UNI: '#ff007a',
  USDC: '#3e73c4',
  USDT: '#26A17B',
  WBTC: '#ef8e19',
  WETH: '#959190',
  wstETH: '#03a9f4',
  wstETHe: '#C4DFE6',
  WXDAI: '#F4B731',
  YFI: '#006ae3',
  ZRX: '#FFFFF0',
  MKR: '#1AAB9B',
  SKY: '#D56ED7',
  ENS: '#2596be',
  stkAAVE: '#997826',
  SPK: '#fa43bd',
  BTC: '#ef8e19',
  USDS: '#ff8c5a',
  cbBTC: '#0052FF',
  sUSDe: '#f2f2f2',
  sUSDE: '#f2f2f2',
  sUSDS: '#00f5aa',
  sUSDC: '#04b9a5',
  stablecoins: '#8e44ad',
  'legacy-rwa': '#e74c3c',
  core: '#3498db',
  spark: '#fa43bd',
  staked: '#f39c12',
  grove: '#27ae60',
  stUSDS: '#bb5cbd',
  Obex: '#003366',
  obex: '#003366',
  onchain_crypto_lending: '#83CD87',
  aaa_corporate_debt: '#CB3758',
  otc_crypto_lending: '#EC8651',
  short_duration_treasury_bills: '#EDC03E',
  private_credit: '#686975',
  basis_trade: '#CB3758',
  core_council_executor_agent_1_backstop_capital: '#3498db',
  core_council_buffer_backstop_capital: '#9c27b0',
  'Core Council Executor Agent 1': '#3498db',
  'Core Council Buffer': '#9c27b0',
  Skybase: '#FFFFFF',
  prysm: '#C08497',
  Prysm: '#C08497',
  ozone: '#4FB3BF',
  Ozone: '#4FB3BF',
  amatsu: '#5B5F97',
  Amatsu: '#5B5F97',
  keel: '#374151',
  Keel: '#374151',
  'Launch Agent 6': '#C08497',
  Osero: '#14799B',
  osero: '#14799B'
};

export const ILKS_PALETTE = {
  'ETH-A': '#959190',
  'ETH-B': '#3e73c4',
  'ETH-C': '#00CEC4',
  'WSTETH-A': '#03a9f4',
  'WSTETH-B': '#C4DFE6',
  'WSTETH-C': '#f27852',
  'WBTC-A': '#ef8e19',
  'WBTC-B': '#f4b731',
  'WBTC-C': '#8BC34A'
};

export const DEFAULT_PALETTE = [
  '#03A9F4',
  '#FF4560',
  '#775DD0',
  '#3F51B5',
  '#4CAF50',
  '#F9CE1D',
  '#008FFB',
  '#00E396',
  '#FEB019',
  '#0276aa',
  '#e20020',
  '#492fa3',
  '#2c387e',
  '#357a38',
  '#bd9905',
  '#0064af',
  '#009e69',
  '#c28000',
  '#014361',
  '#810012',
  '#2a1b5d',
  '#192048',
  '#1e4620',
  '#6c5702',
  '#003964',
  '#005a3c',
  '#6f4900',
  '#22b8fc',
  '#ff6077',
  '#8b75d7',
  '#5767c4',
  '#65bc69',
  '#f9d53e'
];

export const DATE_MAPPING = {
  1: '1D',
  7: '1W',
  30: '1M',
  90: '3M',
  180: '6M',
  365: '1Y'
};

export const ILK_PARAMETERS = {
  buf: 'Buf',
  hole: 'Hole',
  dc_iam_line: 'DC IAM line',
  cusp: 'Cusp',
  chop: 'Chop',
  tip: 'Tip',
  duty: 'Stability fee',
  dust: 'Dust',
  dc_iam_gap: 'DC IAM gap',
  mat: 'Liquidation ratio',
  tail: 'Tail',
  chip: 'Chip',
  dc_iam_ttl: 'DC IAM ttl'
};

export const CORE_DOUGHNUT_MAPPING = {
  Stablecoins: 'stablecoins',
  Spark: 'spark',
  Core: 'core',
  'Legacy RWA': 'legacy-rwa',
  'Cash RWA': 'rwa',
  'Seal Engine': 'seal-engine',
  'Staking Engine': 'staking-engine',
  Grove: 'grove',
  Obex: 'obex',
  Keel: 'keel',
  Osero: 'osero'
};

export const SBE_SWAPS = {
  buy: 'Sell',
  sell: 'Buy',
  buyback: 'Buyback'
};

export const TREASURY_OPERATIONS = {
  transfer: 'Transfer',
  buyback: 'Buyback'
};

export const SURPLUS_ILKS = {
  'RWA014-A': 'RWA014-A',
  'PSM-PAX-A': 'PSM-PAX-A',
  'PSM-GUSD-A': 'PSM-GUSD-A',
  'RWA007-A': 'RWA007-A',
  'RWA015-A': 'RWA015-A',
  'RWA009-A': 'RWA009-A',
  'DIRECT-SPARK-MORPHO-DAI': 'DIRECT-SPARK-MORPHO-DAI',
  'DIRECT-SPARK-DAI': 'DIRECT-SPARK-DAI',
  'DIRECT-AAVEV2-DAI': 'DIRECT-AAVEV2-DAI',
  'DIRECT-COMPV2-DAI': 'DIRECT-COMPV2-DAI',
  'LITE-PSM-USDC-A': 'LITE-PSM-USDC-A'
};

export const ACCOUNTING_TYPES = {
  vest: 'Vest',
  transfer: 'Transfer'
};

export const STABLECOIN_ETHERSCAN_MAPPING = {
  'LITE-PSM-USDC-A': '0xf6e72Db5454dd049d0788e411b06CfAF16853042',
  'PSM-USDC-A': '0x0a59649758aa4d66e25f08dd01271e891fe52199',
  'GUNIV3DAIUSDC2-A': '0x50379f632ca68d36e50cfbc8f78fe16bd1499d1e',
  'GUNIV3DAIUSDC1-A': '0xabddafb225e10b90d798bb8a886238fb835e2053',
  'UNIV2DAIUSDC-A': '0xa81598667ac561986b70ae11bbe2dd5348ed4327',
  'PSM-PAX-A': '0x7bbd8ca5e413bca521c2c80d8d1908616894cf21',
  'PSM-GUSD-A': '0x79a0fa989fb7adf1f8e80c93ee605ebb94f7c6a5',
  'RWA014-A': '0xf082566ac42566cf7b392c8e58116a27eedcbe63'
};

export const TOKEN_ADDRESS_MAPPING = {
  '0x6b175474e89094c44da98b954eedeac495271d0f': 'DAI',
  '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48': 'USDC',
  '0xdc035d45d973e3ec169d2276ddab16f1e407384f': 'USDS',
  '0xa3931d71877c0e7a3148cb7eb4463524fec27fbd': 'sUSDS',
  '0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2': 'MKR',
  '0x56072c95faa701256059aa122697b133aded9279': 'SKY',
  '0x00000000000000000000000000000000000chron': 'CHRON',
  '0x83f20f44975d03b1b09e64809b757c47f942beea': 'sDAI'
};
